import styled from 'styled-components';
//import tw from 'tailwind.macro';
import tw from 'twin.macro';

export const Title = styled.h1`
  ${tw`text-4xl sm:text-6xl lg:text-7xl leading-none font-extrabold tracking-tight font-inter mb-4 text-gray-900`}
`;
export const Dot = styled.span`
  ${tw`text-dv2022-500`}
`;
export const Text = styled.p`
  ${tw`text-lg sm:text-2xl font-medium font-inter mb-2 text-gray-700`}
`;
